export enum OrderStatus {
    Pending = 'Pending',
    Validated = 'Validated',
    ValidationFailed = 'ValidationFailed',
    InTransfer = 'InTransfer',
    Transferred = 'Transferred',
    TransferFailed = 'TransferFailed',
    Received = 'Received',
    Imported = 'Imported',
    ImportFailed = 'ImportFailed',


    // Display Order Status
    ImportByLab = 'vbeiStatus@Lab',
    NotSentError_Submitted = 'vbeiStatusNotSentError',
    NegativeAckReceived_Submitted = 'vbeiStatusNegativeAckReceived',
    Submitted = 'oleiStatusSubmitted',
    PendingState = 'vbeiPending'
}
